import Vue from 'vue'

import { $themeConfig } from '@themeConfig'

const STOPLISTS_API_URL = `${$themeConfig.app.backUrl}/stoplists`
const MENU_API_URL = `${$themeConfig.app.backUrl}/menu`

/**
 * Получение причин для стоп-листа.
 */
export function fetchStopListReasons() {
    return Vue.axios.get(`${STOPLISTS_API_URL}/reasons`)
}

/**
 * Массовое добавление блюд и категорий в стоп-лист.
 * @param {Object} payload - Тело запроса (division_id, reason_id, items, etc.)
 */
export function addItemsToStopListBatch(payload) {
    return Vue.axios.post(`${STOPLISTS_API_URL}/batch`, payload)
}

/**
 * Массовое удаление из стоп-листа.
 * @param {Object} payload - Тело запроса (division_id, menu_items, etc.)
 */
export function deleteItemsFromStopListBatch(payload) {
    return Vue.axios.delete(`${STOPLISTS_API_URL}/batch`, { data: payload })
}

export function fetchDivisionMenu(divisionId, options = {}) {
    if (!divisionId) {
        throw new RangeError(
            'divisionId is required to fetch division menu items'
        )
    }

    const { categoryId, query, filter } = options

    const params = {}

    if (categoryId) {
        params.parent_id = categoryId
    }

    if (query) {
        params.query = query
    }

    params.filter = filter || 'all'

    return Vue.axios.get(`${MENU_API_URL}/${divisionId}`, { params })
}

export function fetchStopListEntries(divisionId, params = {}) {
    if (!divisionId) {
        throw new RangeError(
            'divisionId is required to fetch stop-list entries'
        )
    }

    return Vue.axios.get(`${STOPLISTS_API_URL}`, {
        params: {
            division_id: divisionId,
            active_only: true,
            limit: 1,
            offset: 0,
            ...params,
        },
    })
}
